import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { MdOutlineMail } from "react-icons/md";

import emoji from '../../../assets/emoji.jpg'
import node_logo from '../../../assets/nodejs_logo.webp'
import next_logo from '../../../assets/nextjs3.webp'
import react_logo from '../../../assets/ReactJS.jpg'
import mongodb_logo from '../../../assets/mongodb_logo.jpg'
import electronic_shop from '../../../assets/electronic_shop.png'
import real_estate from '../../../assets/real_estate.png'
import online_shop from '../../../assets/online_shop.png'

import Button from "../../UI/button/button";

import './about_me.css';

const aboutMe = () => (
    <div>
        <div className="about_me_wrapper">
            <div className="about_me_text_wrapper">
                
                <p id="about_me">HI THERE, I'M</p>
                
                <h1>ONORIODE UMUKORO</h1>
                {/* <div>A Software Developer</div> */}
                <p>A Full Stack Engineer with skills in MERN stack based in Delta.</p>
                
                <p>Email: <MdOutlineMail /> onoriodeumukoro8@gmail.com</p>
                
                <p>Contributed to: <a style={{color: "#fff"}} href="https://github.com/faizanv/react-auth-example" target="/">React-Auth</a></p>
                
                <div className="about_me_contact">
                    <p><strong><a style={{color: "#fff", marginRight: "20px"}} href="https://github.com/onoriode8" target="/"><FaGithub style={{color: "#fff"}}/>GitHub</a></strong></p>
                    <p><a style={{color: "#fff"}} href="https://linkedin.com/in/onoriode-umukoro-32b790268" target="/"><FaLinkedin />Linkedin</a></p>
                </div>
                {/* <div>
                    <button>Hire Me</button>
                </div> */}
            </div>
            <div>
                <img className="about_me_img" src={emoji} alt="" />
            </div>
        </div>
        <div className="about_me_skills_wrapper">
            <h2 id="skills">SKILLS</h2>
            <div className="skill_logo_wrapper">
                <div>
                    <img src={node_logo} alt="" className="skills_img" />
                </div>
                <div>
                    <img src={react_logo} alt="" className="skills_img" />
                </div>
                <div>
                    <img src={next_logo} alt="" className="skills_img" />
                </div>
                <div>
                    <img src={mongodb_logo} alt="" className="skills_img" />
                </div>
            </div>
        </div>
        <div style={{color: "#fff", textAlign: "center", marginTop: "5em"}}>
            <h3 id="projects">PROJECT</h3>
            <div className="project_img_wrapper">
                <div className="project_img_wrapper_container">
                    <img src={real_estate} alt="" className="project_img"/>
                    <div>Real Estate Website to buy homes</div>
                    <div><strong>TECH STACK:</strong> React</div>
                    <div>
                        <Button><a href="https://github.com/onoriode8/react_IT_project" target="/" className="button_a_link">Source Code</a></Button>
                        <Button><a href="https://onos-it-project-real-estate.netlify.app/" target="/" className="button_a_link">Visit Site</a></Button>
                    </div>
                </div>
                <div className="project_img_wrapper_container">
                    <img src={online_shop} alt="" className="project_img"/>
                    <div>Full stack Online Shop</div>
                    <div><strong>TECH STACK:</strong> React, Redux,</div>
                    <div>Node, Express, MongoDB</div>
                    <div>
                        <Button><a href="https://github.com/onoriode8/-osb-online-shop" target="/" className="button_a_link">Source Code</a></Button>
                        <Button><a href="https://osb-onlineshop.netlify.app" target="/" className="button_a_link">Visit Site</a></Button>
                    </div>
                </div>
                <div className="project_img_wrapper_container">
                    <img src={electronic_shop} alt="" className="project_img"/>
                    <div>Electronic website for filtering products</div>
                    <div><strong>TECH STACK:</strong> React, Firebase storage.</div>
                    <div>
                        <Button><a className="button_a_link" href="https://github.com/onoriode8/electronic-shopping" target="/" >Source Code</a></Button>
                        <Button><a className="button_a_link" href="https://cute-cranachan-0397d1.netlify.app" target="/" >Visit Site</a></Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default aboutMe;
